import BaseController from "./base_controller.js";
import { api } from "../services/api.js";

/**
 * CashRegisterSidebarController — EPIC-099.20 §7.J.A.
 *
 * Attaché au `<aside class="nm-sidebar">` du layout `app.html` (cf.
 * `frontend/src/partials/sidebar-account.html`). Au connect, interroge
 * `GET /me/cash-register-status` (groupe `api.cashRegister.status`)
 * et révèle la pastille de présence si au moins une session est `open`.
 *
 * Pas de polling : l'état est lu une fois au load du layout. Ouverture
 * et fermeture de session passent par une navigation qui re-load le
 * layout — la pastille se remet à jour naturellement.
 *
 * Gestion d'erreur silencieuse : endpoint down → pastille masquée
 * (signal discret, pas d'alerte). Cohérent avec le patron `badge--red`
 * de Transactions qui n'affiche rien si la requête échoue.
 */
export default class CashRegisterSidebarController extends BaseController {
  static targets = ["presenceDot"];

  async connect() {
    if (!this.hasPresenceDotTarget) return;
    try {
      const response = await api.cashRegister.status();
      const count = Number(response?.openSessionsCount) || 0;
      this.presenceDotTarget.hidden = count === 0;
    } catch (_e) {
      this.presenceDotTarget.hidden = true;
    }
  }
}
